import React, { useState, lazy, Suspense } from 'react'
import ReactGA from 'react-ga4'
import { MdPerson } from 'react-icons/md'

import { useCurrentUser } from '../../../common'

import { FloatingButtonContainer } from './style'

const FloatingButton: React.FC = () => {
  const { isAuthenticated } = useCurrentUser()
  const [open, isOpen] = useState(false)
  const [shouldLoadModal, setShouldLoadModal] = useState(false)

  const ConversionlyModal = lazy(
    () => import('../../SigninSignup/ConversionlyModal')
  )

  const openModal = () => {
    setShouldLoadModal(true)
    isOpen(true)
    ReactGA.event({
      category: 'Sign Up',
      label: 'Floating CTA',
      action: 'User clicked the FLOATING CTA button on the homepage',
    })
  }
  const closeModal = () => isOpen(false)

  if (isAuthenticated) return null
  return (
    <>
      {/** this is to lazy load the modal component only when the button is clicked */}
      {shouldLoadModal && (
        <Suspense fallback={<></>}>
          <ConversionlyModal open={open} onClose={closeModal} />
        </Suspense>
      )}

      <FloatingButtonContainer className="cursor" onClick={openModal}>
        <MdPerson size={20} color="#fff" className="mr-2" />
        Start Planning
      </FloatingButtonContainer>
    </>
  )
}

export default FloatingButton
